import React, { useEffect, useState } from "react";
import { ReactComponent as BackIcon } from "../images/back-icon.svg";
import { ReactComponent as CloseIcon } from "../images/close-icon.svg";
import { ReactComponent as CloudUploadIcon } from "../images/cloud-upload-icon.svg";
import { getSidebarIcon } from "../config/SideBarConfig";
import { RoutesEnum, SidebarEnum } from "../tsmodels/RoutesModel";
import FileInput from "../commonfields/inputs/FileInput";
import DropdownInput from "../commonfields/inputs/DropdownInput";
import { Button } from "reactstrap";
import { IDropdownOptionsModel } from "../tsmodels/SharedModel";
import { useNavigate } from "react-router-dom";
import SpinnerModel from "../commonfields/inputs/SpinnerModel";
import Appservice from "../services/appservice";
import { AxiosError } from "axios";
import { catchError } from "../utils/Utils";
import { toast } from "react-toastify";

const DocumentsCreateNewPage = () => {
  const navigate = useNavigate();

  // states
  const [files, setFiles] = useState([]);
  const [questionnaire, setQuestionnaire] =
    useState<IDropdownOptionsModel | null>(null);
  const [questionnaireOptions, setQuestionnaireOptions] = useState([]);
  const [loader, setLoader] = useState<boolean>(false);
  const service = new Appservice();

  // funcs - handlers
  const goBack = () => navigate(`/${RoutesEnum.DOCUMENTS}`);

  const generateRedirection = () =>
    getDocumentFieldsList(files, questionnaire?.value || "");

  const handleFileChange = (e: any) => {
    setFiles(e);
  };

  const handleQuestionnaire = (selectedOption: any) => {
    setQuestionnaire(selectedOption);
  };

  // funcs - api call
  const getQuestionnireSearch = () => {
    const payLoad = {
      sections: "getQuestionarieTypes",
      screen: "QuestionarieScreen",
    };
    setLoader(true);
    service
      .getQuestionsList(payLoad)
      .then((res: any) => {
        const formattedData = res?.data?.map((p: any) => ({
          value: p?.questionarie_id,
          label: p?.name,
          data: p,
        }));
        setQuestionnaireOptions(formattedData);
      })
      .catch((error: AxiosError) => {
        catchError(error, true);
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const getDocumentFieldsList = (files: any, questionnaire: any) => {
    setLoader(true);
    service
      .getExtractedList(files, questionnaire)
      .then((res: any) => {
        setLoader(true);
        if (res?.data) {
          navigate(
            `/${RoutesEnum.DOCUMENTS}/${RoutesEnum.DETAILS}/${res?.data}`
          );
        }
      })
      .catch((error: any) => {   
        toast.error(error?.response?.data)
      })
      .finally(() => {
        setLoader(false);
      });
  };

  useEffect(() => {
    getQuestionnireSearch();
  }, []);

  return (
    <div className="documents-create-new-page">
      {/* Header */}
      <div className="create-new-header">
        <div className="create-new-header-left">
          <div className="back" onClick={goBack}>
            <BackIcon />
          </div>
          <div className="create-new-header-text">Upload New Document</div>
        </div>
        <div className="create-new-header-right">
          <div className="close-container" onClick={goBack}>
            <span className="close-text">Cancel</span>
            <span className="close-icon">
              <CloseIcon />
            </span>
          </div>
        </div>
      </div>

      {/* File Container */}
      <div className="file-upload-container">
        <div className="header-left">
          <div className="header-icon">
            <CloudUploadIcon />
          </div>
          <div className="header-details">
            <div className="header-primary">Upload files</div>
            <div className="header-secondary">
              Select and upload the files of your choices
            </div>
          </div>
        </div>

        <div className="file-upload-main">
          <FileInput
            value={files}
            onChange={handleFileChange}
            maxSize={30 * 1024 * 1024}
            maxFiles={1}
            accept={{
              "application/pdf": [".pdf"],
              // "image/jpeg": [".jpeg", ".jpg"],
              // "image/png": [".png"],
            }}
            secondaryLabel={"PDF format, up to 50MB"}
          />
        </div>
      </div>

      {/* Questionnaire */}
      <div className="map-ques-container">
        <div className="header-left">
          <div className="header-icon">
            {getSidebarIcon(SidebarEnum.MAPPINGS)}
          </div>
          <div className="header-details">
            <div className="header-primary">Map to Questionnaire</div>
            <div className="header-secondary">
              Select the questionnaire to map this document to
            </div>
          </div>
        </div>

        <div className="map-ques-right">
          <DropdownInput
            value={questionnaire}
            options={questionnaireOptions}
            placeholder="Select a Questionnaire"
            onChange={handleQuestionnaire}
          />
        </div>
      </div>

      <div className="generate-btn">
        <Button
          disabled={!(files?.length > 0 && questionnaire?.value)}
          onClick={generateRedirection}
        >
          {loader ? (
            <SpinnerModel
              value={""}
              color={"primary"}
              size={"sm"}
              type={"border"}
            />
          ) : (
            "Generate"
          )}
        </Button>
      </div>
    </div>
  );
};

export default DocumentsCreateNewPage;
